/** @jsx jsx */
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { PropertyFlag } from 'srs-middleware';
import { PropertyListSelector } from 'components/selectors/propertyListSelector';
// import {  } from '/components/selectors/propertyListSelector';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @returns {*}
 * @constructor
 */

export const TREE_MAP_GROUP_BY_KEY = 0;
export const TreemapWidgetKnobs = ({ cardIndex, endpointQuery, _widgetConfiguration }) => {
	return (
		<React.Fragment>
			<PropertyListSelector
				cardIndex={cardIndex}
				itemIndex={TREE_MAP_GROUP_BY_KEY}
				flags={[PropertyFlag.Hierarchical]}
				label={'Group By'}
				endpointQuery={endpointQuery}
				cy-test="top-level-dropdown-button"
			/>
		</React.Fragment>
	);
};
